import { useCanvasStore } from "../store/canvas-store";

// 下部中央のフローティングツールバー。
// クリック→キャンバス上の任意位置をクリックでオブジェクト配置のフロー（モードステートマシン）。
export function ToolBar(): JSX.Element {
  const tool = useCanvasStore((s) => s.tool);
  const setTool = useCanvasStore((s) => s.setTool);

  const buttons: { tool: typeof tool; label: string; aria: string }[] = [
    { tool: "place-sticky", label: "付箋", aria: "付箋を配置" },
    { tool: "place-shape", label: "図形", aria: "図形を配置" },
    { tool: "place-text", label: "テキスト", aria: "テキストを配置" },
    { tool: "draw-pen", label: "ペン", aria: "ペンで描画" },
  ];

  return (
    <div
      role="toolbar"
      aria-label="キャンバスツールバー"
      style={{
        position: "absolute",
        left: "50%",
        bottom: "24px",
        transform: "translateX(-50%)",
        display: "flex",
        gap: "8px",
        padding: "8px",
        background: "var(--color-surface)",
        boxShadow: "var(--shadow-2)",
        borderRadius: "var(--radius-3)",
        border: "1px solid var(--color-border)",
        zIndex: 10,
      }}
    >
      {buttons.map((b) => (
        <button
          key={b.tool}
          type="button"
          aria-label={b.aria}
          aria-pressed={tool === b.tool}
          onClick={() => setTool(tool === b.tool ? "idle" : b.tool)}
          data-testid={`tool-button-${b.tool}`}
          style={{
            padding: "8px 16px",
            borderRadius: "var(--radius-2)",
            border: "1px solid",
            borderColor: tool === b.tool ? "var(--color-accent)" : "var(--color-border)",
            background: tool === b.tool ? "var(--color-accent)" : "var(--color-surface)",
            color: tool === b.tool ? "var(--color-accent-contrast)" : "var(--color-text)",
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          {b.label}
        </button>
      ))}
    </div>
  );
}
